// Business Information
export const businessInfo = {
  name: "Farrari Laundries",
  phone: "+965 9758 8886",
  whatsapp: "+965 9758 8886",
  email: "info@farrarilife.com",
  address: "SHUWAIKH , INDUSTRIAL AREA 3",
  playStoreLink: "https://play.google.com/store/apps/details?id=com.cleancloudapp.farrarilaundries",
  appStoreLink: "https://apps.apple.com/ms/app/farrari-laundries/id6753220148",
  logo: "https://play-lh.googleusercontent.com/mcFK92E4wFXXK6zAH-XQ6XlrU2mLbxUKjSNRGsJ4qHNUiqHdEOYF7kL1owTlpPynocMB1qj2gR1_5SFz6e4x7w=w240-h480-rw",
  socialMedia: {
    facebook: "https://www.facebook.com/profile.php?id=61557679830150",
    youtube: "https://www.youtube.com/@Farrarilaundrieskw",
    instagram: "https://www.instagram.com/farrari_laundries/",
    snapchat: "https://www.snapchat.com/@farrarilaundry",
    tiktok: "https://www.tiktok.com/@farrari.laundries",
    whatsapp: "https://wa.me/96597588886"
  }
};

// App Benefit Images
export const appBenefitImages = {
  gift: "https://i.pinimg.com/1200x/20/44/cd/2044cd707ec7ae49ef0d02c0e3ed134b.jpg",
  promos: "https://i.pinimg.com/1200x/14/ad/9c/14ad9c009ee5a1838a6b263431617f30.jpg",
  cashless: "https://static.prod-images.emergentagent.com/jobs/6ed4a35f-22a4-4dbd-ba13-972212f8c779/images/7886d6b4c42131e8a4b279072f8fc550061eef73e7f5369c9e5ed90e17708d53.png",
  rewards: "https://i.pinimg.com/1200x/f3/9f/d7/f39fd778cc43c2a3ddeb76c4dfd4ba34.jpg"
};

// Service Categories
export const serviceCategories = [
  { id: 1, name: "Free Pickup & Delivery", slug: "free-pickup-delivery" },
  { id: 2, name: "Wash & Iron", slug: "wash-iron" },
  { id: 3, name: "Iron", slug: "iron" },
  { id: 4, name: "Dry Clean", slug: "dry-clean" }
];

// Branches Data
export const branches = [
  { id: 1, name: "Shuwaikh Main Branch", address: "SHUWAIKH , INDUSTRIAL AREA 3", phone: "+965 9758 8886", location: "SHUWAIKH , INDUSTRIAL AREA 3", lat: 29.319898, lng: 47.926279 },
];

// Franchise Data
export const franchiseData = {
  conceptBrief: {
    title: "Concept Brief",
    content: "Farrari Laundries is Kuwait's premier dry cleaning and laundry service. The company provides 5-star premium services including alterations, bag and shoe cleaning, wedding gown preservation, carpet and upholstery cleaning, and more."
  },
  ownerProfile: {
    title: "Owner Profile",
    content: "We look for franchisees with solid financial resources, strong work ethic, good people skills, high personal standards, and business experience preferably in retail."
  },
  supportPrograms: {
    title: "Support Programs",
    content: "We provide operational support, site selection assistance, marketing support, purchasing discounts, and ongoing research and development."
  },
  franchisingServices: {
    title: "Franchising Services",
    content: "Exclusive license to use trademarks, marketing systems assistance, location selection, construction specifications, staff training, and permanent support."
  },
  franchisingFees: {
    title: "Franchising Fees",
    content: "Our franchise investment is designed to suit different growth models. The Individual Franchise fee starts at approximately KD 9,024, while the Area Development package is approximately KD 49,634 for 10 units. For larger operational setups, the Central Plant investment starts from approximately KD 41,745. In addition to the initial investment, franchise partners are subject to an ongoing 6% royalty fee on gross sales and a 2% to 3% marketing contribution on gross sales. Final amounts in Kuwaiti Dinars may vary slightly depending on the exchange rate at the time of payment."
  }
};
